import React from "react";
import { PageHeader, NavItem } from "./PageHeader";
import { StoreButtons } from "./StoreButtons";

export interface PatientHeaderProps {
  activeNavHref?: string;
  navItems?: NavItem[];
}

export function PatientHeader({ activeNavHref, navItems }: PatientHeaderProps) {
  const defaultNavItems: NavItem[] = [
    { label: "For You", href: "/", selected: activeNavHref === "/" },
    { label: "For Providers", href: "/healthcare", selected: activeNavHref === "/healthcare" },
  ];

  const items = navItems ?? defaultNavItems;

  return (
    <PageHeader
      navItems={items}
      customAction={<StoreButtons />}
      customActionMobile={<StoreButtons stacked />}
    />
  );
}
